import { Bot } from 'lucide-react';
import type { EvalCaseInfo } from '../../types/evalTypes';

/** The case status, plus the versions that wait for review. */
export const CaseStatusBadge = ({ evalCase }: { evalCase: EvalCaseInfo }) => {
  const newer = evalCase.current !== null && evalCase.pendingVersions > 0;
  return (
    <span className="inline-flex items-center gap-1">
      {evalCase.status === 'proposed' && (
        <span className="inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded-full bg-violet-100 text-violet-800">
          <Bot size={10} /> proposed
        </span>
      )}
      {evalCase.status === 'archived' && <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-gray-200 text-gray-700">archived</span>}
      {newer && (
        <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-amber-100 text-amber-800">
          {evalCase.pendingVersions} to review
        </span>
      )}
    </span>
  );
};
